import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import PlannerToDoForm from '../containers/PlannerToDoUserFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerToDoUserEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlannerToDoUserEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) =>
        <div>
          <DocumentHead title={t('planner_to_do_user_route_edit')} />
          <PlannerToDoForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerToDoUserEditScreen;

Logger.log('silly', `PlannerToDoUserEditScreen loaded.`);
